import { MINOR_AGE } from '../../config';
import { getVisitFee, GetVisitFeeProps } from '../../features/get-care/utils/getVisitFeeUtils';
import { VisitBookingParams, VisitInsertUpdateParams } from '../types';

export const getVisitingBookingParamsFromVisitUpdateParam = (
  params: VisitInsertUpdateParams,
): VisitBookingParams => {
  const getVisitFeeProps: GetVisitFeeProps = {
    visitPlan: params.visitDetails?.plan,
    visitType: params.visitDetails?.visitType,
    visitServiceType: params.visitDetails?.serviceType,
  };
  switch (params.visitStatus) {
    case 'booking':
      return {
        visitParams: {
          command: params.visitStatus,
          actor: {
            reference: params.userId,
            type: 'Patient',
            display: params.userDisplayName,
          },
          for: {
            reference: params.userId,
            type: 'Patient',
            display: params.userDisplayName,
          },
        },
      };
    case 'intake':
      return {
        visitParams: {
          command: params.visitStatus,
          platform: 'web',
          visit: {
            reference: params.visitReference ?? '',
            type: 'Visit',
          },
          actor: {
            reference: params.actorReference ?? '',
            type: 'Patient',
            display: params.actorDisplay ?? '',
          },
          patient: {
            reference: params.patientReference ?? '',
            type: 'Patient',
            display: params.patientDisplay ?? '',
          },
          for: {
            reference: params.patientReference ?? '',
            type: 'Patient',
            display: params.patientDisplay ?? '',
          },
          questionnaire: {
            reference: params.questionnaireReference ?? '',
            type: 'Questionnaire',
          },
          questionnaireresponse: {
            reference: params.questionnaireResponseReference ?? '',
            type: 'QuestionnaireResponse',
          },
          serviceType: {
            reference: params.visitDetails?.serviceType?.id ?? '',
            type: params.visitDetails?.serviceType?.resourceType ?? '',
          },
          visitType: {
            visitType: params.visitDetails?.visitType?.visitType ?? '',
            modality: {
              onDemand: true,
              video: true,
            },
          },
          modality: {
            onDemand: true,
            video: true,
          },
          ...(!!params.visitDetails?.plan && {
            selectedPlan: {
              reference: params.visitDetails?.plan?.id,
              type: 'Plan',
              display: params.visitDetails?.plan?.name,
              organizationName: params.visitDetails?.plan?.organization.display,
            },
          }),
          ...(!!params?.visitDetails?.visitType?.visitFee && {
            visitFee: params.visitDetails.visitType.visitFee,
          }),
          ...(!!params?.visitDetails?.visitType?.cancellationFee && {
            cancellationFee: params.visitDetails.visitType.cancellationFee,
          }),
        },
      };
    case 'arrived':
      return {
        visitParams: {
          command: params.visitStatus,
          visit: {
            reference: params.visitReference ?? '',
            type: 'Visit',
          },
          minor_patient: false,
          actor: {
            reference: params.actorReference ?? '',
            type: 'Patient',
            display: params.actorDisplay ?? '',
          },
          patient: {
            reference: params.patientReference ?? '',
            type: 'Patient',
            display: params.patientDisplay ?? '',
          },
          for: {
            reference: params.patientReference ?? '',
            type: 'Patient',
            display: params.patientDisplay ?? '',
          },
          serviceType: {
            reference: params.visitDetails?.serviceType?.id ?? '',
            type: params.visitDetails?.serviceType?.resourceType ?? '',
          },
          visitType: {
            visitType: params.visitDetails?.visitType?.visitType ?? '',
            modality: params.visitDetails?.visitType?.modality,
            visitFee: getVisitFee(getVisitFeeProps),
          },
          ...(!!params.visitDetails?.visitType?.modality && {
            modality: params.visitDetails?.visitType?.modality,
          }),
          ...(!!params.visitDetails?.chiefComplaint && {
            chiefComplaint: {
              reference: params.visitDetails?.chiefComplaint?.questionnaireResponseId,
              type: 'QuestionnaireResponse',
            },
          }),
          ...(!!params.visitDetails?.callbackNumber && {
            callbackNumber: {
              reference: params.visitDetails?.callbackNumber?.questionnaireResponseId,
              type: 'QuestionnaireResponse',
            },
          }),
          patientLocation: {
            system: 'https://direct2care.com/',
            code: params.visitDetails?.state?.value ?? '',
            display: params.visitDetails?.state?.label ?? '',
          },
        },
      };
      break;
    case 'cancelled':
      return {
        visitParams: {
          command: params.visitStatus,
          visit: {
            reference: params.visitReference ?? '',
            type: params.patientDisplay ?? '',
          },
          minor_patient: params?.patientAge ?? 0 < MINOR_AGE ? true : false,
          actor: {
            reference: params.actorReference ?? '',
            type: 'Patient',
            display: params.actorDisplay ?? '',
          },
          patient: {
            reference: params.patientReference ?? '',
            type: 'Patient',
            display: params.patientDisplay ?? '',
          },
          for: {
            reference: params.patientReference ?? '',
            type: 'Patient',
            display: params.patientDisplay ?? '',
          },
          serviceType: {
            reference: params.visitDetails?.serviceType?.id ?? '',
            type: params.visitDetails?.serviceType?.resourceType ?? '',
          },
          visitType: {
            visitType: params.visitDetails?.visitType?.visitType ?? '',
            modality: params.visitDetails?.visitType?.modality,
            visitFee: getVisitFee(getVisitFeeProps),
          },
          modality: params.visitDetails?.visitType?.modality,
          ...(!!params.visitDetails?.chiefComplaint && {
            chiefComplaint: {
              reference: params.visitDetails?.chiefComplaint?.questionnaireResponseId,
              type: 'QuestionnaireResponse',
            },
          }),
          ...(!!params.visitDetails?.callbackNumber && {
            callbackNumber: {
              reference: params.visitDetails?.callbackNumber?.questionnaireResponseId,
              type: 'QuestionnaireResponse',
            },
          }),
          patientLocation: {
            system: 'https://direct2care.com/',
            code: params.visitDetails?.state?.value ?? '',
            display: params.visitDetails?.state?.label ?? '',
          },
          cancellationReason: {
            reason: 'wait_time_too_long',
            additionalDetails: '',
          },
        },
      };
  }
};
